export default {
    component: 'aggregate_parameter_config',
    name: 'aggregate_parameter_config',
    fields: [{
        name: 'Component',
        param: 'component',
        type: 'text',
        required: true,
        identifier: true
      },
      {
        name: 'Configuration',
        param: 'configuration',
        type: 'json',
      }
    ]
  }
